/* eslint-disable react-hooks/exhaustive-deps */
import {
  Box,
  Button,
  Checkbox,
  createTheme,
  Dialog,
  DialogActions,
  FormControl,
  FormControlLabel,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  ThemeProvider,
  Typography
} from '@mui/material';

import { withStyles } from '@material-ui/core';

import { withRouter } from 'react-router-dom';

import React, { useEffect, useState } from 'react';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { POST_AUTHORIZATIONS_SUCCESS, UPDATE_AUTH_TEAM_FAILURE } from './types';
import { TOAST_MESSAGE_SEVERITY_ERROR, TOAST_MESSAGE_SEVERITY_SUCCESS } from 'modules/layout/types';
import { showToast } from 'modules/layout/layout.actions';
import Spinner from 'modules/common/spinner.component';
import { COLOR_PRIMARY, COLOR_SECONDARY, COLOR_WARNING } from 'styles/theme';
import {
  getAuthorizationSummaries,
  postAuthorizationSummary,
  updateTeam,
  getSimilarAuthorizations
} from './store/actions/authorizations.actions';
import AdvancedSearch from 'modules/common/advancedSearch.component';
import { getClientDetails } from 'modules/clients/clients.actions';
import { getInternalUsers } from 'modules/common/common.actions';
import { GET_CLIENT_DETAILS_FAILURE } from 'modules/clients/types';
import { formatDateForInput } from 'utilities/common';
import GooglePlacesAddressAutocomplete from 'modules/intake/form/googlePlacesAddressAutocomplete.component';
import { findCountryId, findProvinceId } from 'modules/common/utils';

const styles = theme => ({
  wideControl: {
    minWidth: 174
  },
  section: {
    marginBottom: theme.spacing(2)
  }
});

const CreateAuthorizationDialog = props => {
  const {
    countriesEnum,
    provincesEnum,
    fileTypesEnum,
    ownershipTypesEnum,
    contactTypesEnum,
    moveTypesEnum,
    moveReasonsEnum,
    unmappedClients,
    internalUsers,
    getSimilarAuthorizations
  } = props;

  const theme = createTheme({
    palette: {
      primary: COLOR_PRIMARY,
      secondary: COLOR_SECONDARY,
      warning: COLOR_WARNING
    }
  });

  const [isLoadingModal, setIsLoadingModal] = useState(false);
  const [isDirty, setIsDirty] = useState(false);

  // client fields
  const [clientId, setClientId] = useState(null);
  const [clientName, setClientName] = useState('');
  const [divisions, setDivisions] = useState([]);
  const [policies, setPolicies] = useState([]);

  // TRC fields
  const [internalUserId, setInternalUserId] = useState(null);

  // Family fields
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');

  // Main authorization fields

  const [authorizationFileTypeId, setAuthorizationFileTypeId] = useState(null);
  const [divisionId, setDivisionId] = useState(null);
  const [relocationPolicyId, setRelocationPolicyId] = useState(null);
  const [webAccessEmailAddress, setWebAccessEmailAddress] = useState('');
  const [webAccessMobileNumber, setWebAccessMobileNumber] = useState('');
  const [isVip, setIsVip] = useState(false);
  const [department, setDepartment] = useState('');
  const [jobTitle, setJobTitle] = useState('');
  const [preferredContactTypeId, setPreferredContactTypeId] = useState(null);
  const [moveTypeId, setMoveTypeId] = useState(null);
  const [moveReasonId, setMoveReasonId] = useState(null);
  //   const [moveCap, setMoveCap] = useState(0);
  //   const [moveMiles, setMoveMiles] = useState(0);
  const [newJobStartDate, setNewJobStartDate] = useState(null);

  // Departure fields
  const [departureOwnershipTypeId, setDepartureOwnershipTypeId] = useState(null);
  const [addressLine1, setAddressLine1] = useState('');
  const [addressLine2, setAddressLine2] = useState('');
  const [city, setCity] = useState('');
  const [county, setCounty] = useState('');
  const [countryId, setCountryId] = useState(null);
  const [provinceId, setProvinceId] = useState(null);
  const [zipcode, setZipcode] = useState('');

  // Destination fields
  const [destinationOwnershipTypeId, setDestinationOwnershipTypeId] = useState(null);
  const [destinationCity, setDestinationCity] = useState('');
  const [destinationCounty, setDestinationCounty] = useState('');
  const [destinationCountryId, setDestinationCountryId] = useState(null);
  const [destinationProvinceId, setDestinationProvinceId] = useState(null);

  // Address search states
  const [departureSearchValue, setDepartureSearchValue] = useState('');
  const [destinationSearchValue, setDestinationSearchValue] = useState('');

  const [similarAuths, setSimilarAuths] = useState([]);
  const [hasSimilarAuths, setHasSimilarAuths] = useState(false);
  // const [isCheckingSimilar, setIsCheckingSimilar] = useState(false);

  const [showSimilarDialog, setShowSimilarDialog] = useState(false);
  const [similarReviewed, setSimilarReviewed] = useState(false);
  const [selectedSimilarFileId, setSelectedSimilarFileId] = useState(null);
  const [selectedSimilarIntakeId, setSelectedSimilarIntakeId] = useState(null);
  const [emailCheckTouched, setEmailCheckTouched] = useState(false);
  const [phoneCheckTouched, setPhoneCheckTouched] = useState(false);
  const [selectedNextFileType, setSelectedNextFileType] = useState(null);
  const [selectedFileNumber, setSelectedFileNumber] = useState(null);

  useEffect(() => {
    if (!emailCheckTouched && !phoneCheckTouched) return;

    const email = (webAccessEmailAddress || '').trim();
    const phone = (webAccessMobileNumber || '').trim();

    if (!clientId || (!email && !phone)) return;

    const t = setTimeout(() => {
      checkSimilarAuthorizations();
    }, 350);

    return () => clearTimeout(t);
  }, [webAccessEmailAddress, webAccessMobileNumber, clientId, emailCheckTouched, phoneCheckTouched]);

  const checkSimilarAuthorizations = async () => {
    const email = (webAccessEmailAddress || '').trim();
    const phone = (webAccessMobileNumber || '').trim();

    // only run when we have client + division and at least one contact value
    if (!clientId || (!email && !phone)) {
      setSimilarAuths([]);
      setHasSimilarAuths(false);
      setSimilarReviewed(false);
      return;
    }

    try {
      const criteria = {
        clientId: Number(clientId),
        divisionId: Number(0),
        emailAddress: email || '',
        phoneNumber: phone || ''
      };

      // action should now POST criteria
      const resp = await getSimilarAuthorizations(criteria);
      const rows = resp?.response || [];

      setSimilarAuths(rows);
      setHasSimilarAuths(rows.length > 0);
      setSimilarReviewed(rows.length === 0 || selectedSimilarFileId !== null);
    } catch {
      setSimilarAuths([]);
      setHasSimilarAuths(false);
      setSimilarReviewed(false);
    }
  };
  // Handle departure address selection from Google Places
  const handleDepartureAddressSelect = (event, details) => {
    if (details) {
      setAddressLine1(details.streetAddress || details.formattedAddress || '');
      setCity(details.city || '');
      setCounty(details.county || '');
      setZipcode(details.zipcode || '');

      const foundCountryId = findCountryId(details.country, details.countryLongName, countriesEnum) || null;
      if (foundCountryId) {
        setCountryId(foundCountryId);
        const foundProvinceId = findProvinceId(details.state, details.stateLongName, provincesEnum) || null;
        if (foundProvinceId) {
          setProvinceId(foundProvinceId);
        }
      }

      setDepartureSearchValue(details.streetAddress || details.formattedAddress || '');
    }
  };

  // Handle destination address selection from Google Places
  const handleDestinationAddressSelect = (event, details) => {
    if (details) {
      setDestinationCity(details.city || '');
      setDestinationCounty(details.county || '');

      const foundCountryId = findCountryId(details.country, details.countryLongName, countriesEnum) || null;
      if (foundCountryId) {
        setDestinationCountryId(foundCountryId);
        const foundProvinceId = findProvinceId(details.state, details.stateLongName, provincesEnum) || null;
        if (foundProvinceId) {
          setDestinationProvinceId(foundProvinceId);
        }
      }

      setDestinationSearchValue(details.city || '');
    }
  };

  const createAuthorization = async () => {
    if (hasSimilarAuths && !similarReviewed) {
      setShowSimilarDialog(true);
      return;
    }
    setIsLoadingModal(true);

    const basicAuthInfo = {
      authorizationDetails: {
        clientId: clientId,
        relocationPolicyId: relocationPolicyId, // Create dropdown once client policy data is available
        authorizationFileStatusId: '9a5b2115-645c-479c-93a4-19a5cc4bb8b2', // Default to active
        authorizationFileTypeId: authorizationFileTypeId,
        webAccessEmailAddress: webAccessEmailAddress,
        webAccessMobileNumber: webAccessMobileNumber,
        isTextMessageConsent: false,
        auth0UserId: '',
        hoptreeResult: '',
        hoptreeId: '',
        mfaEnrollmentId: '',
        isVip: isVip,
        isWelcomeEmailSent: false,
        isWebAccessGranted: false,
        departureOwnershipTypeId: departureOwnershipTypeId,
        destinationOwnershipTypeId: destinationOwnershipTypeId,
        department: department,
        jobTitle: jobTitle,
        preferredContactTypeId: preferredContactTypeId,
        moveTypeId: moveTypeId,
        moveReasonId: moveReasonId,
        moveCap: null,
        moveMiles: null,
        isShortTermAssignment: false,
        initiationDate: new Date(),
        interviewDate: null,
        newJobStartDate: null,
        estimatedMoveDate: null,
        cancelledDate: null,
        completedDate: null,
        divisionId: divisionId,
        maritalStatusId: '31d2b090-88fc-4f3f-b453-30a8792930dc', // Default to other, will be updated in Intake Record if provided by user
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date()
      },
      departureAddress: {
        addressTypeId: 'aff1270e-2713-4026-a667-872ae9757825',
        addressLine1: addressLine1,
        addressLine2: addressLine2,
        addressLine3: '',
        city: city,
        county: county,
        countryId: countryId,
        provinceId: provinceId,
        zipcode: zipcode,
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date()
      },
      destinationAddress: {
        addressTypeId: 'c467fd82-e2d4-4d26-8827-5df0a0b5c6a5',
        city: destinationCity,
        county: destinationCounty,
        countryId: destinationCountryId,
        provinceId: destinationProvinceId,
        addedBy: 1,
        addedOn: new Date(),
        modifiedBy: 1,
        modifiedOn: new Date()
      },
      firstName: firstName,
      lastName: lastName,
      fileId: selectedSimilarFileId,
      intakeId: selectedSimilarIntakeId
    };

    const postAuthResp = await props.postAuthorizationSummary(basicAuthInfo);
    if (postAuthResp.type === POST_AUTHORIZATIONS_SUCCESS) {
      // Assign Relocation Counselor to the newly created authorization
      const newFileId = postAuthResp.response.authorizationDetails.fileId;

      const newTeamInfo = [
        {
          fileId: newFileId,
          authorizationFileRepresentativeTypeId: '78bf4f32-f363-4de0-8797-bc35835e7eb2',
          internalUserId: internalUserId,
          addedBy: 1,
          modifiedBy: 1
        }
      ];

      const updateTeamResp = await props.updateTeam(newTeamInfo, newFileId);

      if (updateTeamResp.type === UPDATE_AUTH_TEAM_FAILURE) {
        props.showToast('Authorization created but failed to assign RC. Please assign manually.', {
          severity: TOAST_MESSAGE_SEVERITY_ERROR
        });
      } else {
        await props.getAuthorizationSummaries();
        props.showToast('Successfully created new authorization and assigned RC.', { severity: TOAST_MESSAGE_SEVERITY_SUCCESS });
      }

      props.onCancel();
      // props.history.push(`/authorizations/${newFileId}`);
    } else {
      props.showToast('Failed to create authorization, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
    }

    setIsLoadingModal(false);
  };

  const getClientInfo = async (id, val) => {
    if (id.length !== 0) {
      const clientResp = await props.getClientDetails(id);
      if (clientResp.type === GET_CLIENT_DETAILS_FAILURE) {
        props.showToast('Failed to get client details, please try again.', { severity: TOAST_MESSAGE_SEVERITY_ERROR });
      } else {
        let details = clientResp.response;
        setClientId(id);
        setClientName(val);
        setPolicies(details.clientRelocationPolicies);
        setDivisions(details.clientDivisions);
        if (details.clientDivisions.length === 1) {
          setDivisionId(details.clientDivisions[0].clientDivisionId);
        }
      }
    } else {
      setPolicies([]);
      setDivisions([]);
      setDivisionId(null);
      setRelocationPolicyId(null);
      setClientId(null);
      setClientName('');
    }
  };

  useEffect(() => {
    // Fetch internal users on component mount
    if (!internalUsers || internalUsers.length === 0) {
      props.getInternalUsers();
    }
  }, []);

  useEffect(() => {
    if (
      firstName.length === 0 ||
      lastName.length === 0 ||
      webAccessEmailAddress.length === 0 ||
      webAccessMobileNumber.length === 0 ||
      authorizationFileTypeId === null ||
      preferredContactTypeId === null ||
      moveTypeId === null ||
      moveReasonId === null ||
      departureOwnershipTypeId === null ||
      addressLine1.length === 0 ||
      city.length === 0 ||
      county.length === 0 ||
      countryId === null ||
      zipcode.length === 0 ||
      destinationOwnershipTypeId === null ||
      destinationCity.length === 0 ||
      provinceId === null ||
      destinationCountryId === null ||
      destinationProvinceId === null ||
      clientId === null ||
      internalUserId === null
    ) {
      setIsDirty(true);
    } else {
      setIsDirty(false);
    }
  }, [
    firstName,
    lastName,
    clientId,
    authorizationFileTypeId,
    webAccessEmailAddress,
    webAccessMobileNumber,
    preferredContactTypeId,
    moveTypeId,
    moveReasonId,
    departureOwnershipTypeId,
    addressLine1,
    city,
    county,
    countryId,
    provinceId,
    zipcode,
    destinationOwnershipTypeId,
    destinationCity,
    destinationCountryId,
    destinationProvinceId,
    internalUserId
  ]);

  const [searchingColumns] = useState([
    { name: 'clientRecordId', title: 'Id' },
    { name: 'clientCode', title: 'Client Code' },
    { name: 'shortName', title: 'Client Name' }
  ]);

  const [searchingColumnExtensions] = useState([
    { columnName: 'clientRecordId', width: 150 },
    { columnName: 'clientCode', width: 200 },
    { columnName: 'shortName', width: 300 }
  ]);
  // Updated create authorization modal for AB#1655 - comment for deploying

  return (
    <ThemeProvider theme={theme}>
      <Dialog open={props.open} fullWidth={false} maxWidth={'lg'}>
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
          <div className="row justify-space-between align-center">
            <Typography
              variant="h5"
              sx={{
                fontSize: '1.3125rem',
                fontWeight: 'bold'
              }}
            >
              Create Auth (Skip Intake)
            </Typography>
          </div>
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
          <div className="row justify-space-between align-center">
            <Typography
              variant="h5"
              sx={{
                fontSize: '1.175rem',
                fontWeight: 'bold',
                marginBottom: '-16px',
                marginTop: '-16px'
              }}
            >
              Client Information
            </Typography>
          </div>
          <Box>
            <div className={props.classes.mb2}>
              <Typography variant="subtitle2">Client</Typography>
            </div>
            <div>
              <AdvancedSearch
                labelText={''}
                displayValueAccessorKey={'shortName'}
                saveIdValueAccessorKey={'clientRecordId'}
                searchingCriteria={searchingColumns}
                searchingCriteriaExtensions={searchingColumnExtensions}
                searchingRows={unmappedClients}
                value={clientName}
                id={clientId}
                setIdValue={(id, val) => {
                  getClientInfo(id, val);
                }}
              />
            </div>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'clientRecordId'}>
                Division
              </InputLabel>
              <Select
                labelId={'divisionId'}
                key={'divisionId'}
                label={'divisionId'}
                name={'divisionId'}
                required={divisions && divisions?.length > 0}
                disabled={clientId === null || (divisions && divisions?.length === 0)}
                value={divisionId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setDivisionId(e.target.value)}
              >
                {divisions.map(opt => (
                  <MenuItem key={opt.clientDivisionId} value={opt.clientDivisionId} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.divisionName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '100%' }}>
          <hr />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
          <div className="row justify-space-between align-center">
            <Typography
              variant="h5"
              sx={{
                fontSize: '1.175rem',
                fontWeight: 'bold',
                marginBottom: '-16px',
                marginTop: '-16px'
              }}
            >
              TRC Information
            </Typography>
          </div>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'internalUserId'}>
                Relocation Counselor
              </InputLabel>
              <Select
                labelId={'internalUserId'}
                key={'internalUserId'}
                label={'internalUserId'}
                name={'internalUserId'}
                required={true}
                disabled={clientId == null}
                value={internalUserId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setInternalUserId(e.target.value)}
              >
                {internalUsers &&
                  internalUsers.map(opt => (
                    <MenuItem key={opt.internalUserId} value={opt.internalUserId} sx={{ margin: 'dense' }} disabled={false}>
                      {opt.firstName} {opt.lastName} ({opt.displayUserName})
                    </MenuItem>
                  ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
        </Box>
        <Box sx={{ width: '100%' }}>
          <hr />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
          <div className="row justify-space-between align-center">
            <Typography
              variant="h5"
              sx={{
                fontSize: '1.175rem',
                fontWeight: 'bold',
                marginBottom: '-16px',
                marginTop: '-16px'
              }}
            >
              Employee Information
            </Typography>
          </div>
          <Box>
            <TextField
              key={'firstName'}
              label={'First Name'}
              name={'firstName'}
              required={false}
              disabled={clientId == null}
              value={firstName}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setFirstName(e.target.value)}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'lastName'}
              label={'Last Name'}
              name={'lastName'}
              required={false}
              disabled={clientId == null}
              value={lastName}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setLastName(e.target.value)}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'clientRecordId'}>
                File Type
              </InputLabel>
              <Select
                labelId={'authorizationFileTypeId'}
                key={'authorizationFileTypeId'}
                label={'authorizationFileTypeId'}
                name={'authorizationFileTypeId'}
                required={true}
                disabled={clientId == null}
                value={authorizationFileTypeId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setAuthorizationFileTypeId(e.target.value)}
              >
                {fileTypesEnum.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'department'}
              label={'Department'}
              name={'department'}
              required={false}
              disabled={clientId == null}
              value={department}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setDepartment(e.target.value)}
            />
          </Box>
          <Box>
            <TextField
              key={'jobTitle'}
              label={'Job Title'}
              name={'jobTitle'}
              required={false}
              disabled={clientId == null}
              value={jobTitle}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setJobTitle(e.target.value)}
            />
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '20px', marginBottom: '1px', marginLeft: '-50px' }}>
              <FormControlLabel
                key={'isVip'}
                name={'isVip'}
                label={'Is VIP'}
                labelPlacement="start"
                control={<Checkbox />}
                required={false}
                disabled={clientId == null}
                checked={isVip}
                variant="standard"
                margin="dense"
                sx={{ marginTop: '6px', minWidth: '120px', maxWidth: '360px' }}
                onClick={e => setIsVip(e.target.checked ? true : false)}
              />
            </FormControl>
          </Box>
        </Box>

        <Box sx={{ width: '100%' }}>
          <hr />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
          <div className="row justify-space-between align-center">
            <Typography
              variant="h5"
              sx={{
                fontSize: '1.175rem',
                fontWeight: 'bold',
                marginBottom: '-16px',
                marginTop: '-16px'
              }}
            >
              Policy Information
            </Typography>
          </div>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'clientRecordId'}>
                Policy
              </InputLabel>
              <Select
                labelId={'relocationPolicyId'}
                key={'relocationPolicyId'}
                label={'relocationPolicyId'}
                name={'relocationPolicyId'}
                required={policies && policies?.length > 0}
                disabled={clientId == null}
                value={relocationPolicyId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setRelocationPolicyId(e.target.value)}
              >
                {policies.map(opt => (
                  <MenuItem
                    key={opt.policy.relocationPolicyId}
                    value={opt.policy.relocationPolicyId}
                    sx={{ margin: 'dense' }}
                    disabled={false}
                  >
                    {opt.policy.policyDescription}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'clientRecordId'}>
                Move Type
              </InputLabel>
              <Select
                labelId={'moveTypeId'}
                key={'moveTypeId'}
                label={'moveTypeId'}
                name={'moveTypeId'}
                required={true}
                disabled={clientId == null}
                value={moveTypeId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setMoveTypeId(e.target.value)}
              >
                {moveTypesEnum.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'clientRecordId'}>
                Move Reason
              </InputLabel>
              <Select
                labelId={'moveReasonId'}
                key={'moveReasonId'}
                label={'moveReasonId'}
                name={'moveReasonId'}
                required={true}
                disabled={clientId == null}
                value={moveReasonId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setMoveReasonId(e.target.value)}
              >
                {moveReasonsEnum.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'newJobStartDate'}
              label={'New Job Start'}
              name={'newJobStartDate'}
              required={false}
              disabled={clientId == null}
              value={formatDateForInput(newJobStartDate)}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              type="date"
              onChange={e => setNewJobStartDate(e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Box>
        </Box>

        <Box sx={{ width: '100%' }}>
          <hr />
        </Box>

        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
          <div className="row justify-space-between align-center">
            <Typography
              variant="h5"
              sx={{
                fontSize: '1.175rem',
                fontWeight: 'bold',
                marginBottom: '-16px',
                marginTop: '-16px'
              }}
            >
              Contact Information
            </Typography>
          </div>
          <Box>
            <TextField
              key={'emailAddress'}
              label={'Email Address'}
              name={'emailAddress'}
              required={false}
              disabled={clientId == null}
              value={webAccessEmailAddress}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => {
                setWebAccessEmailAddress(e.target.value);
                setSimilarReviewed(false);
                setHasSimilarAuths(false);
                setSimilarAuths([]);
                setSelectedSimilarFileId(null);
                setSelectedSimilarIntakeId(null);
              }}
              onBlur={() => {
                setEmailCheckTouched(true);
                checkSimilarAuthorizations();
              }}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'mobileNumber'}
              label={'Mobile Number'}
              name={'mobileNumber'}
              required={false}
              disabled={clientId == null}
              value={webAccessMobileNumber}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => {
                setWebAccessMobileNumber(e.target.value);
                setSimilarReviewed(false);
                setHasSimilarAuths(false);
                setSimilarAuths([]);
                setSelectedSimilarFileId(null);
                setSelectedSimilarIntakeId(null);
              }}
              onBlur={() => {
                setPhoneCheckTouched(true);
                checkSimilarAuthorizations();
              }}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'clientRecordId'}>
                Preferred Contact Type
              </InputLabel>
              <Select
                labelId={'preferredContactTypeId'}
                key={'preferredContactTypeId'}
                label={'preferredContactTypeId'}
                name={'preferredContactTypeId'}
                required={true}
                disabled={clientId == null}
                value={preferredContactTypeId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setPreferredContactTypeId(e.target.value)}
              >
                {contactTypesEnum.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          {hasSimilarAuths && (
            <Box>
              <Typography variant="caption" color="warning.main">
                Similar authorization exists.{' '}
                <Button size="small" onClick={() => setShowSimilarDialog(true)}>
                  View
                </Button>
              </Typography>
            </Box>
          )}
        </Box>

        <Box sx={{ width: '100%' }}>
          <hr />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
          <div className="row justify-space-between align-center">
            <Typography
              variant="h5"
              sx={{
                fontSize: '1.175rem',
                fontWeight: 'bold',
                marginBottom: '-16px',
                marginTop: '-16px'
              }}
            >
              Departure Information
            </Typography>
          </div>
          <Box sx={{ width: '100%', marginBottom: 1, paddingX: 0 }}>
            <Typography variant="subtitle2" sx={{ marginBottom: 1, color: 'primary.main', fontWeight: 'bold' }}>
              Quick Address Search
            </Typography>
            <GooglePlacesAddressAutocomplete
              label="Search Departure Address"
              placeholder="Type to search and autofill departure address..."
              initialValue={departureSearchValue}
              onSelect={handleDepartureAddressSelect}
              onInputClear={() => setDepartureSearchValue('')}
              onInputEdit={newValue => setDepartureSearchValue(newValue)}
              disabled={clientId == null}
            />
            <Typography variant="caption" display="block" sx={{ marginTop: 0.5, color: 'text.secondary' }}>
              Search for an address to automatically fill the fields below, or fill them manually
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'departureOwnershipTypeId'}>
                Ownership Type
              </InputLabel>
              <Select
                labelId={'departureOwnershipTypeId'}
                key={'departureOwnershipTypeId'}
                label={'departureOwnershipTypeId'}
                name={'departureOwnershipTypeId'}
                required={true}
                disabled={clientId == null}
                value={departureOwnershipTypeId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setDepartureOwnershipTypeId(e.target.value)}
              >
                {ownershipTypesEnum.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'addressLine1'}
              label={'Address Line 1'}
              name={'addressLine1'}
              required={false}
              disabled={clientId == null}
              value={addressLine1}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setAddressLine1(e.target.value)}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'addressLine2'}
              label={'Address Line 2'}
              name={'addressLine2'}
              required={false}
              disabled={clientId == null}
              value={addressLine2}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setAddressLine2(e.target.value)}
            />
          </Box>
          <Box>
            <TextField
              key={'city'}
              label={'City'}
              name={'city'}
              required={false}
              disabled={clientId == null}
              value={city}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setCity(e.target.value)}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'county'}
              label={'County'}
              name={'county'}
              required={false}
              disabled={clientId == null}
              value={county}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setCounty(e.target.value)}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'countryId'}>
                Country
              </InputLabel>
              <Select
                labelId={'countryId'}
                key={'countryId'}
                label={'countryId'}
                name={'countryId'}
                required={true}
                disabled={clientId == null}
                value={countryId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setCountryId(e.target.value)}
              >
                {countriesEnum.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'provinceId'}>
                Province
              </InputLabel>
              <Select
                labelId={'provinceId'}
                key={'provinceId'}
                label={'provinceId'}
                name={'provinceId'}
                required={true}
                disabled={clientId == null || countryId == null}
                value={provinceId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setProvinceId(e.target.value)}
              >
                {countryId &&
                  provincesEnum
                    .filter(pe => pe.countryId === countryId)
                    .map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                        {opt.title}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'zipcode'}
              label={'Zip Code'}
              name={'zipcode'}
              required={false}
              disabled={clientId == null}
              value={zipcode}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setZipcode(e.target.value)}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
        </Box>

        <Box sx={{ width: '100%' }}>
          <hr />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'row', padding: '20px', flexWrap: 'wrap', gap: '20px' }}>
          <div className="row justify-space-between align-center">
            <Typography
              variant="h5"
              sx={{
                fontSize: '1.175rem',
                fontWeight: 'bold',
                marginBottom: '-16px',
                marginTop: '-16px'
              }}
            >
              Destination Information
            </Typography>
          </div>
          <Box sx={{ width: '100%', marginBottom: 1, paddingX: 0 }}>
            <Typography variant="subtitle2" sx={{ marginBottom: 1, color: 'primary.main', fontWeight: 'bold' }}>
              Quick Address Search
            </Typography>
            <GooglePlacesAddressAutocomplete
              label="Search Destination Address"
              placeholder="Type to search and autofill destination address..."
              initialValue={destinationSearchValue}
              onSelect={handleDestinationAddressSelect}
              onInputClear={() => setDestinationSearchValue('')}
              onInputEdit={newValue => setDestinationSearchValue(newValue)}
              disabled={clientId == null}
            />
            <Typography variant="caption" display="block" sx={{ marginTop: 0.5, color: 'text.secondary' }}>
              Search for an address to automatically fill the fields below, or fill them manually
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'destinationOwnershipTypeId'}>
                Ownership Type
              </InputLabel>
              <Select
                labelId={'destinationOwnershipTypeId'}
                key={'destinationOwnershipTypeId'}
                label={'destinationOwnershipTypeId'}
                name={'destinationOwnershipTypeId'}
                required={true}
                disabled={clientId == null}
                value={destinationOwnershipTypeId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setDestinationOwnershipTypeId(e.target.value)}
              >
                {ownershipTypesEnum.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'destinationCity'}
              label={'City'}
              name={'destinationCity'}
              required={false}
              disabled={clientId == null}
              value={destinationCity}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setDestinationCity(e.target.value)}
            />
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <TextField
              key={'destinationCounty'}
              label={'County'}
              name={'destinationCounty'}
              required={false}
              disabled={clientId == null}
              value={destinationCounty}
              sx={{ maxWidth: '360px' }}
              margin="dense"
              variant="standard"
              onChange={e => setDestinationCounty(e.target.value)}
            />
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'destinationCountryId'}>
                Country
              </InputLabel>
              <Select
                labelId={'destinationCountryId'}
                key={'destinationCountryId'}
                label={'destinationCountryId'}
                name={'destinationCountryId'}
                required={true}
                disabled={clientId == null}
                value={destinationCountryId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setDestinationCountryId(e.target.value)}
              >
                {countriesEnum.map(opt => (
                  <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                    {opt.title}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
          <Box>
            <FormControl sx={{ marginTop: '6px' }}>
              <InputLabel sx={{ marginLeft: '-15px', marginTop: '7px' }} id={'destinationProvinceId'}>
                Province
              </InputLabel>
              <Select
                labelId={'destinationProvinceId'}
                key={'destinationProvinceId'}
                label={'destinationProvinceId'}
                name={'destinationProvinceId'}
                required={true}
                disabled={clientId == null || destinationCountryId == null}
                value={destinationProvinceId}
                margin="dense"
                variant="standard"
                sx={{ marginTop: '6px', marginBottom: '6px', maxWidth: '360px', minWidth: '180px' }}
                onChange={e => setDestinationProvinceId(e.target.value)}
              >
                {destinationCountryId &&
                  provincesEnum
                    .filter(pe => pe.countryId === destinationCountryId)
                    .map(opt => (
                      <MenuItem key={opt.id} value={opt.id} sx={{ margin: 'dense' }} disabled={false}>
                        {opt.title}
                      </MenuItem>
                    ))}
              </Select>
            </FormControl>
            <Typography variant="caption" display="block" color="primary">
              Required
            </Typography>
          </Box>
        </Box>

        <DialogActions sx={{ p: '1.25rem', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          {isLoadingModal && <Spinner />}

          {!isLoadingModal && (
            <>
              <Box sx={{ minHeight: 20 }}>
                {(selectedSimilarFileId || selectedSimilarIntakeId) && selectedFileNumber && (
                  <Typography variant="body2" color="text.secondary">
                    Creating a '{selectedNextFileType}' file for {`${selectedFileNumber}`}.
                  </Typography>
                )}
              </Box>

              <Box sx={{ display: 'flex', gap: 1 }}>
                <Button onClick={() => props.onCancel()}>Cancel</Button>
                <Button onClick={createAuthorization} color="primary" type="submit" variant="contained" disabled={isDirty}>
                  Create Authorization
                </Button>
              </Box>
            </>
          )}
        </DialogActions>
        <Dialog
          open={showSimilarDialog}
          onClose={() => {
            setSimilarReviewed(true);
            setShowSimilarDialog(false);
          }}
          maxWidth="lg"
          fullWidth
        >
          <Box sx={{ p: 3, pb: 1 }}>
            <Typography variant="h6" sx={{ fontWeight: 700 }}>
              Similar Authorizations Found
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>
              We found existing authorizations with the same email address. Select one to link this authorization, or continue without
              selecting.
            </Typography>
          </Box>

          <Box sx={{ px: 3, pb: 2 }}>
            <Box
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                borderRadius: 2,
                overflow: 'hidden',
                maxHeight: 360,
                overflowY: 'auto'
              }}
            >
              <Box
                sx={{
                  display: 'grid',
                  gridTemplateColumns: '56px 1fr 1.2fr 1.2fr 1.2fr 1fr 1fr',
                  gap: 1,
                  px: 2,
                  py: 1.25,
                  bgcolor: 'grey.100',
                  borderBottom: '1px solid',
                  borderColor: 'divider',
                  fontWeight: 600,
                  fontSize: 13
                }}
              >
                <Box>Select</Box>
                <Box>File #</Box>
                <Box>EE Name</Box>
                <Box>Policy</Box>
                <Box>Origin</Box>
                <Box>Destination</Box>
                <Box>Date</Box>
              </Box>

              {similarAuths.length === 0 ? (
                <Box sx={{ p: 2 }}>
                  <Typography variant="body2" color="text.secondary">
                    No similar authorizations found.
                  </Typography>
                </Box>
              ) : (
                similarAuths.map(row => {
                  const isIntake = row.intakeId !== null && row.intakeId !== undefined && row.intakeId !== '' && row.intakeId !== 0;
                  const isSelected = selectedSimilarFileId === row.fileId || selectedSimilarIntakeId === row.intakeId;
                  const rowId = isIntake ? `i-${row.intakeId}` : `f-${row.fileId}`;
                  return (
                    <Box
                      key={rowId}
                      onClick={() => {
                        if (isIntake) {
                          setSelectedSimilarIntakeId(row.intakeId);
                          setSelectedSimilarFileId(null);
                          const suffix = (row?.nextFileNumber || '')
                            .trim()
                            .slice(-1)
                            .toUpperCase();
                          setSelectedNextFileType(['B', 'C', 'D', 'c', 'b', 'd'].includes(suffix) ? suffix : '');
                          setSelectedFileNumber(row?.fileNumber || '');
                        } else {
                          setSelectedSimilarFileId(row.fileId);
                          setSelectedSimilarIntakeId(null);
                          const suffix = (row?.nextFileNumber || '')
                            .trim()
                            .slice(-1)
                            .toUpperCase();
                          setSelectedNextFileType(['B', 'C', 'D', 'c', 'b', 'd'].includes(suffix) ? suffix : '');
                          setSelectedFileNumber(row?.fileNumber || '');
                        }
                      }}
                      sx={{
                        display: 'grid',
                        gridTemplateColumns: '56px 1fr 1.2fr 1.2fr 1.2fr 1fr 1fr',
                        gap: 1,
                        px: 2,
                        py: 1.25,
                        alignItems: 'center',
                        cursor: 'pointer',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                        bgcolor: isSelected ? 'primary.50' : 'background.paper',
                        '&:hover': { bgcolor: isSelected ? 'primary.100' : 'action.hover' }
                      }}
                    >
                      <Box>
                        <Checkbox
                          checked={isSelected}
                          onChange={() => {
                            if (isIntake) {
                              setSelectedSimilarIntakeId(isSelected ? null : row.intakeId);
                            } else {
                              setSelectedSimilarFileId(isSelected ? null : row.fileId);
                            }
                          }}
                          onClick={e => e.stopPropagation()}
                          size="small"
                        />
                      </Box>
                      <Typography variant="body2" sx={{ fontWeight: isSelected ? 700 : 500 }}>
                        {row.fileNumber || '-'}
                      </Typography>
                      <Typography variant="body2">{row.fullName || '-'}</Typography>
                      <Typography variant="body2">{row.policy || '-'}</Typography>
                      <Typography variant="body2">{row.origin || '-'}</Typography>
                      <Typography variant="body2">{row.destination || '-'}</Typography>
                      <Typography variant="body2">{row.date ? new Date(row.date).toLocaleDateString() : '-'}</Typography>
                    </Box>
                  );
                })
              )}
            </Box>

            {(selectedSimilarFileId || selectedSimilarIntakeId) && (
              <Typography variant="caption" color="primary" sx={{ mt: 1, display: 'block' }}>
                {selectedSimilarFileId
                  ? `Selected File ID: ${selectedSimilarFileId} - Creating a ${selectedNextFileType} File`
                  : `Selected Intake ID: ${selectedSimilarIntakeId} - Creating a ${selectedNextFileType} File`}
              </Typography>
            )}
          </Box>

          <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button
              onClick={() => {
                setSelectedSimilarFileId(null);
                setSelectedSimilarIntakeId(null);
                setSimilarReviewed(true);
                setShowSimilarDialog(false);
                setSelectedNextFileType(null);
                setSelectedFileNumber(null);
              }}
            >
              Continue Without Selecting
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                setSimilarReviewed(true);
                setShowSimilarDialog(false);
              }}
            >
              Use Selected
            </Button>
          </DialogActions>
        </Dialog>
      </Dialog>
    </ThemeProvider>
  );
};

const mapStateToProps = state => {
  const {
    countries,
    provinces,
    authorizationFileTypes,
    ownershipTypes,
    preferredContactTypes,
    moveTypes,
    moveReasons
  } = state.enumerations.allEnums;
  const { unmappedClients } = state.clients;
  const { internalUsers } = state.common;

  return {
    countriesEnum: countries,
    provincesEnum: provinces,
    fileTypesEnum: authorizationFileTypes,
    ownershipTypesEnum: ownershipTypes,
    contactTypesEnum: preferredContactTypes,
    moveTypesEnum: moveTypes,
    moveReasonsEnum: moveReasons,
    unmappedClients: unmappedClients,
    internalUsers: internalUsers
  };
};

export default compose(
  withStyles(styles),
  withRouter,
  connect(mapStateToProps, {
    postAuthorizationSummary,
    showToast,
    getClientDetails,
    getAuthorizationSummaries,
    updateTeam,
    getInternalUsers,
    getSimilarAuthorizations
  })
)(CreateAuthorizationDialog);
